// extracted by mini-css-extract-plugin
export default {"logo":"Description_logo__DIrpj","descriptionContainer":"Description_descriptionContainer__1bUv+","text":"Description_text__HDpTc"};